import { useLocation } from 'react-router';
import config from '@/config';
import { captureException } from '@/lib/sentry';
import { useAppState } from './AppState';
async function sendAnalyticsRequest(event) {
    if (!config.enableAnalytics) {
        return;
    }
    try {
        const query = new URLSearchParams(event);
        await fetch(encodeURI(`${config.locatorAnalyticsPath}?${query.toString()}`), {
            method: 'GET',
            headers: {
                'X-Requested-With': config.packageVersion,
            },
        });
    }
    catch (error) {
        captureException(error, { analytics: 'sendHit' }, { event });
    }
}
export default function useAnalytics() {
    const { locale, sessionId } = useAppState();
    const location = useLocation();
    const path = typeof window !== 'undefined' ? window?.location?.pathname : '/';
    function createEvent(event) {
        return {
            ...event,
            dp: `${location.pathname}${location.search}${location.hash}`,
            cid: sessionId,
            ul: locale === 'cy' ? 'cy-GB' : 'en-GB',
            dh: `${config.hostname}${path}`,
            vp: `${window.innerWidth}x${window.innerHeight}`,
        };
    }
    function recordView(title) {
        const event = createEvent({
            dt: title ?? 'View',
            t: 'pageview',
        });
        sendAnalyticsRequest(event);
    }
    function recordEvent({ category, action, }) {
        const event = createEvent({
            ec: category,
            ea: action,
            t: 'event',
        });
        sendAnalyticsRequest(event);
    }
    return { recordView, recordEvent };
}
